import { render, staticRenderFns } from "./ProductsFilter.vue?vue&type=template&id=fe87ca70"
import script from "./ProductsFilter.vue?vue&type=script&lang=js"
export * from "./ProductsFilter.vue?vue&type=script&lang=js"
import style0 from "./ProductsFilter.vue?vue&type=style&index=0&id=fe87ca70&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports